// // src/features/tables/TableCard.jsx
// import React from 'react';
// import {
//   Card,
//   CardHeader,
//   CardActions,
//   Stack,
//   Button,
//   Badge,
//   Typography,
//   Box
// } from '@mui/material';
// import EditIcon    from '@mui/icons-material/Edit';
// import MergeIcon   from '@mui/icons-material/CallMerge';
// import BlockIcon   from '@mui/icons-material/Block';
// import ReserveIcon from '@mui/icons-material/Chair';
// import ViewIcon    from '@mui/icons-material/Visibility';
// import UnblockIcon from '@mui/icons-material/LockOpen';
// import { TABLE_STATUSES } from 'utils/constant';


// const TableCard = ({
//   name,
//   seats,
//   status,
//   merged,
//   mergedWithCount,
//   orderId,
//   onEdit,
//   onReserve,
//   onBlock,
//   onMerge,
//   onCreateOrder,
//   onViewOrder,
//   onUnblock,
// }) => {
//   // Render the header badge if merged or flagCount
//   const header = (
//     <CardHeader
//       title={
//         <Stack direction="row" alignItems="center" spacing={1}>
//           <Typography variant="subtitle1">{name}</Typography>
//           {merged && (
//             <Badge badgeContent={`+${mergedWithCount}`} color="primary" />
//           )}
//         </Stack>
//       }
//       subheader={`${seats} seats`}
//       sx={{ pb: 0 }}
//     />
//   );

//   // Determine which action buttons to show
//   const actions = [];
//   // Always allow Edit
//   actions.push(
//     <Button key="edit" startIcon={<EditIcon />} size="small" onClick={onEdit}>
//       Edit
//     </Button>
//   );

//   switch (status) {
//     case TABLE_STATUSES.AVAILABLE:
//       actions.push(
//         <Button key="reserve" startIcon={<ReserveIcon />} size="small" onClick={onReserve}>
//           Reserve
//         </Button>,
//         <Button key="block" startIcon={<BlockIcon />} size="small" onClick={onBlock}>
//           Block
//         </Button>,
//         <Button key="merge" startIcon={<MergeIcon />} size="small" onClick={onMerge}>
//           Merge
//         </Button>,
//         <Box flexGrow={1} />,
//         <Button key="create" variant="contained" size="small" onClick={onCreateOrder}>
//           Create Order
//         </Button>
//       );
//       break;

//     case TABLE_STATUSES.RESERVED:
//       actions.push(
//         <Button key="release" startIcon={<UnblockIcon />} size="small" onClick={onUnblock}>
//           Release
//         </Button>,
//         <Box flexGrow={1} />,
//         <Button key="create" variant="contained" size="small" onClick={onCreateOrder}>
//           Create Order
//         </Button>
//       );
//       break;

//     case TABLE_STATUSES.OCCUPIED:
//       actions.push(
//         <Button key="view" startIcon={<ViewIcon />} size="small" onClick={onViewOrder}>
//           View Order
//         </Button>
//       );
//       break;

//     case TABLE_STATUSES.BLOCKED:
//       actions.push(
//         <Button key="unblock" startIcon={<UnblockIcon />} size="small" onClick={onUnblock}>
//           Unblock
//         </Button>
//       );
//       break;

//     case TABLE_STATUSES.SCHEDULED:
//       actions.push(
//         <Button key="view" startIcon={<ViewIcon />} size="small" onClick={onViewOrder}>
//           View Order
//         </Button>
//       );
//       break;

//     default:
//       break;
//   }

//   return (
//     <Card variant="outlined" sx={{ width: 240, m: 1 }}>
//       {header}
//       <CardActions>
//         <Stack direction="row" flexWrap="wrap" spacing={1} width="100%">
//           {actions}
//         </Stack>
//       </CardActions>
//     </Card>
//   );
// };

// export default TableCard;



import React from 'react';
import { styled } from '@mui/material/styles';
import {
    Card,
    CardContent,
    Typography,
    Stack,
    IconButton,
    Button,
    Badge,
    Box,
    Divider,
    Tooltip,
} from '@mui/material';

import EditIcon from '@mui/icons-material/Edit';
import BlockIcon from '@mui/icons-material/Block';
import PeopleIcon from '@mui/icons-material/People';
import DescriptionIcon from '@mui/icons-material/Description';
import { ReactComponent as MergeIcon } from 'assests/merge-table.svg';
import { TABLE_STATUSES } from 'utils/constant';
import CustomTypography from 'components/Fileds/CustomTypography';
import theme from 'theme/ThemeContext';
import { Delete, DoneAll, Info, RadioButtonUncheckedOutlined, TableRestaurant } from '@mui/icons-material';
import MergedTablesPopover from 'components/Fileds/CustomPopOver';
import TableRestaurantOutlinedIcon from '@mui/icons-material/TableRestaurantOutlined';

// fixed width card to match your grid
const StyledCard = styled(Card)(({ theme }) => ({
    width: "300px",
    borderRadius: '10px',
    border: '1px solid #BDBDBD',
    boxShadow: 'none',
    padding: '15px 10px',
}));

const StatusText = styled(Typography)(({ status }) => {
    let color = '#1F9619';
    if (status === TABLE_STATUSES.OCCUPIED) color = '#E86400';
    if (status === TABLE_STATUSES.RESERVED) color = '#E86400';
    if (status === TABLE_STATUSES.BLOCKED) color = '#D41616';
    if (status === TABLE_STATUSES.SCHEDULED) color = '#9c27b0';
    return { fontSize: '0.875rem', fontWeight: 400, color };
});

const ActionButton = styled(Button)(({ bgcolor, fontcolor }) => ({
    minWidth: 0,
    width: '50px',
    height: '50px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '5px',
    textTransform: 'none',
    fontSize: '0.75rem',
    padding: '8px 10px',
    backgroundColor: bgcolor || 'transparent',
    color: fontcolor || '#000',
    border: `1px solid ${fontcolor}`,
    borderRadius: '5px',
    lineHeight: 'normal',
    '&:hover': {
        backgroundColor: bgcolor ? bgcolor : 'rgba(0,0,0,0.04)',
    },
    '& .MuiButton-startIcon': {
        marginLeft: '0px'
    }
}));

export default function TableCard({
    table,
    onEdit,
    onReserve,
    onBlock,
    onMerge,
    onSplit,
    onCreateOrder,
    onViewOrder,
    onUnblock,
    onRelease,
    onDelete,
    onGenerateQr,
    onViewQr
}) {
    return (
        <StyledCard>
            <CardContent sx={{ padding: '0px !important' }}>
                {/* HEADER */}
                <Box className='d-flex align-items-center justify-content-between' sx={{ mb: 0.5 }}>
                    <Box className='d-flex align-items-center' sx={{ gap: '20px', width: '100%' }}>
                        <CustomTypography
                            variant={"subtitle1"}
                            label={table?.table_no}
                            sx={{ fontSize: '1rem', fontWeight: 600, mb: 0 }}
                        />
                        {table?.merged && (
                            <Tooltip title={<MergedTablesPopover tableData={table} type={"tableinfo"} />} arrow placement="right"
                                enterTouchDelay={0}   // show immediately on tap
                                leaveTouchDelay={3000} // stays open for 3s unless tapped away
                                interactive           // allow clicks inside tooltip
                                componentsProps={{
                                    tooltip: {
                                        sx: {
                                            backgroundColor: '#1297DE',
                                            color: '#fff',
                                            p: '10px',
                                            marginLeft: '30px !important',
                                            width: '300px',
                                            borderRadius: '8px',
                                            '& .MuiTooltip-arrow': {
                                                color: '#1297DE',
                                                fontSize: 20, // <-- controls arrow size
                                            },
                                        }
                                    },
                                    // arrow: {
                                    //     sx: {
                                    //         color: "#1297DE", // arrow color matches background
                                    //         fontSize: 20,
                                    //     }
                                    // }
                                }}
                            >
                                <Badge
                                    badgeContent={`+${table?.children?.length}`}
                                    sx={{ '& .MuiBadge-badge': { fontSize: '0.75rem', backgroundColor: '#1297DE', color: '#fff', padding: '4px 8px' } }}
                                />
                            </Tooltip>
                        )}
                    </Box>
                    <Box className='d-flex align-items-center' sx={{ gap: 0.5 }}>
                        <PeopleIcon fontSize="small" sx={{ color: theme.palette.drawermenuitem.main }} />
                        <CustomTypography
                            variant={"subtitle2"}
                            label={table?.totalCapacity}
                            sx={{ fontSize: '1rem', fontWeight: 600, color: theme.palette.drawermenuitem.main, mb: 0 }}
                        />
                    </Box>
                </Box>

                {/* STATUS LINE */}
                <Box className='d-flex align-items-start justify-content-between'>
                    <Box className='d-flex align-items-center' sx={{ gap: 0.5 }}>
                        <StatusText status={table?.status}>
                            {table?.status?.charAt(0).toUpperCase() + table?.status.slice(1)}
                        </StatusText>
                        {table?.merged && table?.status !== 'occupied' &&
                            <>
                                <Divider orientation="vertical" flexItem sx={{ borderColor: `#1297DE !important` }} />
                                <CustomTypography
                                    variant="body2"
                                    label={`Merged`}
                                    sx={{ mb: 0, color: '#1297DE' }}
                                />
                            </>
                        }
                        {table?.reservation?.order_id && (
                            <>
                                <Divider orientation="vertical" flexItem sx={{ borderColor: `${theme.palette.drawermenuitem.main} !important` }} />
                                <Typography variant="body2" sx={{ color: theme.palette.drawermenuitem.main }}>
                                    Order #{table?.reservation?.order_id}
                                </Typography>
                            </>
                        )}
                    </Box>
                    <Box className='d-flex align-items-center' sx={{ gap: 1 }}>
                        <IconButton
                            onClick={(e) => {
                                e.stopPropagation();
                                onEdit(table);
                            }}
                            size="small"
                            sx={{ p: 0 }}
                            aria-label="edit table"
                        >
                            <EditIcon sx={{ color: theme.palette.drawermenuitem.main, fontSize: '20px' }} />
                        </IconButton>
                        {table?.status === TABLE_STATUSES.RESERVED && table?.reservation &&
                            <Tooltip title={<MergedTablesPopover tableData={table} type={"info"} />} arrow placement="right"
                                enterTouchDelay={0}   // show immediately on tap
                                leaveTouchDelay={3000} // stays open for 3s unless tapped away
                                interactive           // allow clicks inside tooltip
                                componentsProps={{
                                    tooltip: {
                                        sx: {
                                            backgroundColor: theme.palette.drawermenuitem.main,
                                            color: '#fff',
                                            p: '10px',
                                            marginLeft: '10px !important',
                                            width: '300px',
                                            borderRadius: '8px',
                                            '& .MuiTooltip-arrow': {
                                                color: theme.palette.drawermenuitem.main,
                                                fontSize: 20, // <-- controls arrow size
                                            },
                                        }
                                    },
                                }}
                            >
                                <Info fontSize="small" sx={{ color: theme.palette.drawermenuitem.main }} />
                            </Tooltip>
                        }
                        {(table?.notes || table?.children?.some(child => child?.notes)) &&
                            // <Box className='notes-info'>
                            <Tooltip title={<MergedTablesPopover tableData={table} type={"notes"} />} arrow placement="right"
                                enterTouchDelay={0}   // show immediately on tap
                                leaveTouchDelay={3000} // stays open for 3s unless tapped away
                                interactive           // allow clicks inside tooltip
                                componentsProps={{
                                    tooltip: {
                                        sx: {
                                            backgroundColor: theme.palette.drawermenuitem.main,
                                            color: '#fff',
                                            p: '10px',
                                            marginLeft: '10px !important',
                                            width: '300px',
                                            borderRadius: '8px',
                                            '& .MuiTooltip-arrow': {
                                                color: theme.palette.drawermenuitem.main,
                                                fontSize: 20, // <-- controls arrow size
                                            },
                                        }
                                    },
                                }}
                            >
                                <DescriptionIcon fontSize="small" sx={{ color: theme.palette.drawermenuitem.main }} />
                            </Tooltip>
                            // </Box>
                        }
                        {table?.status === 'available' && (
                            <IconButton
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onDelete(table);
                                }}
                                size="small"
                                sx={{ p: 0 }}
                                aria-label="delete table"
                            >
                                <Delete sx={{ fill: '#dc2828', fontSize: '20px' }} />
                            </IconButton>
                        )}
                    </Box>
                </Box>
            </CardContent>
            <Divider sx={{ my: '10px', borderColor: '#D9D9D9' }} />

            {/* ACTIONS */}
            <Box>
                <Box className='d-flex align-items-center' gap={1}>
                    {table?.qr_code_url ? (
                        <ActionButton
                            onClick={() => onViewQr(table)}
                            bgcolor={"rgba(231, 231, 231, 1)"}
                            fontcolor='#000'
                        >
                            View QR
                        </ActionButton>
                    ) : (
                        <ActionButton
                            onClick={() => onGenerateQr(table)}
                            bgcolor={"rgba(231, 231, 231, 1)"}
                            fontcolor='#000'
                        >
                            Create QR
                        </ActionButton>
                    )}

                    {table?.status === TABLE_STATUSES.AVAILABLE && (
                        <>
                            <ActionButton
                                bgcolor="rgba(217, 255, 215, 0.4)"
                                fontcolor="rgba(46, 125, 50, 1)"
                                startIcon={<TableRestaurant fontSize="small" />}
                                onClick={onReserve}
                            >
                                Reserve
                            </ActionButton>
                            {!table?.merged &&
                                <ActionButton
                                    bgcolor="rgba(250, 155, 155, 0.4)"
                                    fontcolor="rgba(212, 22, 22, 1)"
                                    startIcon={<BlockIcon fontSize="small" />}
                                    onClick={onBlock}
                                >
                                    Block
                                </ActionButton>
                            }
                            {table?.merged
                                ? <ActionButton
                                    bgcolor="rgba(164, 223, 255, 0.4)"
                                    fontcolor="rgba(18, 151, 222, 1)"
                                    startIcon={<RadioButtonUncheckedOutlined fontSize="small" />}
                                    onClick={onSplit}
                                >
                                    Split
                                </ActionButton>
                                : <ActionButton
                                    bgcolor="rgba(164, 223, 255, 0.4)"
                                    fontcolor="rgba(18, 151, 222, 1)"
                                    startIcon={<MergeIcon fontSize="small" />}
                                    onClick={onMerge}
                                >
                                    Merge
                                </ActionButton>
                            }
                            <ActionButton
                                variant="outlined"
                                onClick={onCreateOrder}
                                bgcolor={"#fff"}
                                fontcolor={"#000"}
                            >
                                Create Order
                            </ActionButton>
                        </>
                    )}

                    {table?.status === TABLE_STATUSES.RESERVED && (
                        <>
                            <ActionButton
                                bgcolor="rgba(217, 255, 215, 0.4)"
                                fontcolor="rgba(46, 125, 50, 1)"
                                startIcon={<TableRestaurantOutlinedIcon fontSize="small" />}
                                onClick={onRelease}
                            >
                                Release
                            </ActionButton>
                            <ActionButton
                                variant="outlined"
                                onClick={onCreateOrder}
                                bgcolor={"#fff"}
                                fontcolor={"#000"}
                            >
                                Create Order
                            </ActionButton>
                        </>
                    )}

                    {table?.status === TABLE_STATUSES.OCCUPIED && (
                        <>
                            <ActionButton
                                bgcolor="#db7706e6"
                                fontcolor="#fff"
                                // startIcon={<TableRestaurantOutlinedIcon fontSize="small" />}
                                onClick={onRelease}
                            >
                                Change Table
                            </ActionButton>
                            <ActionButton
                                bgcolor="#000"
                                fontcolor="#fff"
                                onClick={onViewOrder}
                            >
                                View Order
                            </ActionButton>
                        </>
                    )}

                    {table?.status === TABLE_STATUSES.BLOCKED && (
                        <ActionButton
                            bgcolor="rgba(193, 255, 196, 0.4)"
                            fontcolor="rgba(46, 125, 50, 1)"
                            startIcon={<DoneAll fontSize="small" />}
                            onClick={onUnblock}
                        >
                            Unblock
                        </ActionButton>
                    )}


                    {table?.status === TABLE_STATUSES.SCHEDULED && (
                        <>
                            <ActionButton
                                bgcolor="#db7706e6"
                                fontcolor="#fff"
                                // startIcon={<TableRestaurantOutlinedIcon fontSize="small" />}
                                onClick={onRelease}
                            >
                                Change Table
                            </ActionButton>
                            <ActionButton
                                bgcolor="#000"
                                fontcolor="#fff"
                                onClick={onViewOrder}
                            >
                                View Order
                            </ActionButton>
                        </>
                    )}
                </Box>
            </Box>
        </StyledCard>
    );
}
